import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import {
  ContainerDropdown,
  HeaderContainer,
  Search,
  SelectedQuestion,
  Title,
  TimeQuestion,
  WatchQuestionLink,
  QuestionInfo,
  WrittenHeaderContainer,
  WrittenTitleContainer,
  WrittenQuestionOrder,
  WrittenTitle,
  WrittenChartContent,
} from './styles';

const BaseChartCard = (props) => {
  const {
    children,
    onSearchChange,
    search,
    isTimeOnQuestion,
    questionTitle,
    questionLabel,
    questionType,
    questionId,
  } = props;

  const { projectId = '' } = useParams() || {};

  const titleTimeOnQuestion = isTimeOnQuestion ? 'Time on Question' : questionTitle;

  if (onSearchChange) {
    return (
      <>
        <WrittenHeaderContainer>
          <WrittenTitleContainer>
            <WrittenQuestionOrder>{questionTitle}</WrittenQuestionOrder>
            <WrittenTitle>{`${questionLabel} (${questionType})`}</WrittenTitle>
          </WrittenTitleContainer>

          {!isTimeOnQuestion && (
            <WatchQuestionLink
              rel="internal"
              target="_blank"
              href={`/projects/${projectId}/videos/questions/${questionId}`}
            >
              Watch
              {' '}
              {questionTitle}
            </WatchQuestionLink>
          )}
        </WrittenHeaderContainer>

        <Search
          placeholder="Search written responses"
          input={{
            icon: 'search',
            iconPosition: 'left',
          }}
          loading={false}
          onSearchChange={onSearchChange}
          open={false}
          value={search}
          width="390px"
        />

        <WrittenChartContent>
          {children}
        </WrittenChartContent>
      </>
    );
  }

  return (
    <>
      <HeaderContainer>
        {isTimeOnQuestion ? <TimeQuestion>{titleTimeOnQuestion}</TimeQuestion> : <Title>{questionTitle}</Title>}

        {!isTimeOnQuestion && (
          <QuestionInfo>
            <WatchQuestionLink
              rel="internal"
              target="_blank"
              href={`/projects/${projectId}/videos/questions/${questionId}`}
            >
              Watch
              {' '}
              {questionTitle}
            </WatchQuestionLink>
          </QuestionInfo>
        )}
      </HeaderContainer>

      {!isTimeOnQuestion && (
        <ContainerDropdown>
          <SelectedQuestion>
            {questionLabel}
            {` (${questionType})`}
          </SelectedQuestion>
        </ContainerDropdown>
      )}

      {children}
    </>
  );
};

BaseChartCard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.oneOf([null, undefined]),
  ]),
  onSearchChange: PropTypes.func,
  search: PropTypes.string,
  isTimeOnQuestion: PropTypes.bool,
  questionTitle: PropTypes.string.isRequired,
  questionLabel: PropTypes.string.isRequired,
  questionType: PropTypes.string.isRequired,
  questionId: PropTypes.string.isRequired,
};

BaseChartCard.defaultProps = {
  children: null,
  onSearchChange: null,
  search: null,
  isTimeOnQuestion: false,
};

export default BaseChartCard;
